function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import ChatLine from "./ChatLine";

class ChatView extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "scrollToBottom", (behavior = "smooth") => {
      if (!this.msgEnd) {
        return;
      }

      this.msgEnd.scrollIntoView({
        behavior
      });
    });
  }

  componentDidMount() {
    this.scrollToBottom("auto");
    window.addEventListener("resize", () => {
      this.scrollToBottom();
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => {
      this.scrollToBottom();
    });
  }

  componentDidUpdate() {
    setTimeout(() => {
      this.scrollToBottom("smooth");
    }, 400);
  }

  render() {
    const previousMessages = this.props.previousmessages.map((msgArr, index) => {
      return /*#__PURE__*/React.createElement(ChatLine, {
        message: msgArr,
        key: index
      });
    });
    const messages = this.props.messages.map((msgArr, index) => {
      return /*#__PURE__*/React.createElement(ChatLine, {
        message: msgArr,
        key: index
      });
    });
    return /*#__PURE__*/React.createElement("div", _extends({
      id: "chat-view",
      className: this.props.className || ""
    }, this.props), previousMessages, /*#__PURE__*/React.createElement("h4", {
      id: "chat-view-date-header"
    }, moment().format("MMMM D, YYYY")), messages, this.props.agenttyping ? /*#__PURE__*/React.createElement("div", {
      className: "chat-notification"
    }, "Advisor is typing ...") : null, /*#__PURE__*/React.createElement("div", {
      id: "message-scroll-anchor",
      ref: el => {
        this.msgEnd = el;
      }
    }));
  }

}

ChatView.propTypes = {
  previousmessages: PropTypes.array,
  agenttyping: PropTypes.bool,
  messages: PropTypes.array,
  className: PropTypes.string
};
export default ChatView;